import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import UILink from 'UIComponents/link/UILink';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import WebhookInfoModal from 'automation-ui-enrollment/components/eventEnrollment/steps/WebhookInfoModal';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookEventsDescription = ({
  title
}) => {
  const [showWebhookInfoModal, setShowWebhookInfoModal] = useState(false);
  const trackEvent = useTrackEvent();
  const handleOpenWebhookInfoModal = () => {
    trackEvent(Trackables.WEBHOOK_TRIGGER_INTERACTION, {
      actionType: 'OPENED_INFO_MODAL'
    });
    setShowWebhookInfoModal(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showWebhookInfoModal && /*#__PURE__*/_jsx(WebhookInfoModal, {
      onClose: () => setShowWebhookInfoModal(false)
    }), title !== null && title !== void 0 ? title : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.redesign.events.webhookEvents.description"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(UILink, {
        onClick: handleOpenWebhookInfoModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.events.webhookEvents.whatsAWebhook"
        })
      })
    })]
  });
};
export default WebhookEventsDescription;